import army from "./army";
import content from "./content";
import exemption from "./exemption";
import night from "./night";
import resource from "./resource";
import selftaught from "./selftaught";
import skill from "./skill";
import web from "./web";

/**
 * 华博特项目接口文档
 */
export default {
  army,
  content,
  exemption,
  night,
  resource,
  selftaught,
  skill,
  web,
};
